<template>
	<div id="app">
		<v-dialog
			v-model="isTimerOut"
			persistent
			v-if="isTimerOut"
			width="500px"
			overlay-opacity="0.98"
			overlay-color="rgb(200, 200, 200)">
			<v-card>
				<v-card-title class="headline card-header fixed-card-title2 py-2">{{ $t('session-expired') }}</v-card-title>
				<v-card-text class="pb-2 pt-4">
					{{ $t('your-session-has-expired-due-to-inactivity-please-login-again') }}<br />
					{{ $t('you-can-change-the-timeout-duration-in-settings') }}
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="primary2" style="color: white" elevation="0" @click="signout">OK</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<router-view />
	</div>
</template>
<script>
import { mapState } from 'vuex';
function throttle (func, limit) {
	let inThrottle;
	return function (...args) {
		const context = this;
		if (!inThrottle) {
			func.apply(context, args);
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}

export default {
	data () {
		return {
			events: ['click', 'mousedown', 'mousemove', 'keydown', 'scroll'],
			logoutTimer: null,
			throttledFunction: null,
			isTimerOut: false,
		};
	},
	computed: {
		...mapState({
			detailedUser: (state) => state.users.detailedUser,
			authUser: (state) => state.authentication.userData,
		}),
	},
	methods: {
		on_resize () {
			this.$store.commit('SET_SCREEN_SIZE', {
				height: window.innerHeight,
				width: window.innerWidth,
			});
		},
		setTimeout () {
			if (this.authUser !== null) {
				this.logoutTimer = setTimeout(this.logout, (this.$cookies.get('inactivityExpirationTime') ?? 86400) * 1000);
			}
		},
		resetTimer () {
			clearTimeout(this.logoutTimer);
			this.setTimeout();
		},
		logout () {
			if (this.detailedUser !== null) {
				const patientId = this.detailedUser?.userData.id;
				if ([3, 4, 7].includes(this.authUser.roleData.id)) {
					const getTimeTrackingBody = {
						PatientId: patientId,
					};
					this.$store.dispatch('timetracking/getNotFinishedWithPatient', getTimeTrackingBody).then(() => {
						if (this.startTimeTrackingInfo.data.length === 0) {
							this.isTimerOut = true;
							return;
						}
						const stopTimeTrackingBody = {
							trackingId: this.startTimeTrackingInfo.data[0].id,
						};
						this.$store.dispatch('timetracking/stoptrackingwithpatient', stopTimeTrackingBody).then(() => {
							this.isTimerOut = true;
						});
					});
				} else {
					this.isTimerOut = true;
				}
			} else {
				this.isTimerOut = true;
			}
		},
		signout () {
			this.isTimerOut = false;
			this.$router.push({ name: 'Login' });
		},
	},
	async mounted () {
		this.throttledFunction = throttle(this.resetTimer, 3000);
		this.events.forEach((event) => {
			window.addEventListener(event, this.throttledFunction);
		});
		this.$store.commit('SET_SCREEN_SIZE', {
			height: window.innerHeight,
			width: window.innerWidth,
		});
		window.addEventListener('resize', throttle(this.on_resize, 200));
		if (this.$cookies.get('language') !== null) {
			this.$i18n.locale = this.$cookies.get('language');
		}
		this.setTimeout();
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.on_resize);
		this.events.forEach((event) => {
			window.removeEventListener(event, this.throttledFunction);
		});
		clearTimeout(this.logoutTimer);
	},
	watch: {
		authUser (newVal) {
			if (newVal) {
				this.setTimeout();
			} else {
				this.isTimerOut = false;
				clearTimeout(this.logoutTimer);
			}
		},
	},
};
</script>
<style lang="scss">
#app {
	font-family: Roboto, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	background-color: #f9f8fb;
}

#nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}
div {
	scrollbar-width: thin !important;
}
.v-data-table-header th {
	white-space: nowrap;
}
::-webkit-scrollbar {
	width: 0px !important;
}
tr {
	cursor: pointer;
}
</style>
